/**
* 系统管理 角色管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>集团账号</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!--
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" placeholder="名称"></el-input>
      </el-form-item> -->

      <el-form-item label="操作记录" prop="type">
        <el-select v-model="formInline.type" placeholder="请选择" size="medium">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit1()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column prop="logContent" label=" 内容">
      </el-table-column>
      <el-table-column prop="logType" label="状态">

        <template slot-scope="scope">
          <div v-if="scope.row.logType==10 ">下线</div>
          <div v-if="scope.row.logType==7 ">上线</div>
        </template>
      </el-table-column>
      <el-table-column prop="createUser" label="操作人">

      </el-table-column>
      <el-table-column prop="logTime" label="操作时间">

      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


  </div>
</template>

<script>
  import {
    getLogPage,
    getMchGroupListPage,
    createGroupManageUser
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        menuAccessshow: false, //控制数据权限显示与隐藏
        title: '添加',
        editForm: {
          roleId: '',
          menuIds: '',
        },
        editForm1: {
          groupId: '',
          loginName: '',
          password: '',
        },
        jituan: [],
        investorId: '',
        listData1: [

        ],
        options:[
          {
            label:'全部',
            value:1
          },          {
            label:'上架',
            value:7
          },          {
            label:'下架',
            value:10
          },
        ],
        value1: '',
        formInline: {
          page: 1,
          limit: 20,
          type: 1,
          name: '',
          token: localStorage.getItem('logintoken')
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },


    watch: {},



    created() {
      this.getdata(this.formInline)
      // this.getTMerchantGroupListPage()

    },

    methods: {
      // 获取角色列表
      getdata(parameter) {
        this.loading = true
        let pro = {
          type: parameter.type,
          "page": parameter.page,
          "pageSize": parameter.limit

        }
        getLogPage(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = res.data.pageNum
              this.pageparm.pageSize = res.data.pageSize
              this.pageparm.total = res.data.total

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      },


      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },




      // 关闭编辑、增加弹出框
      closeDialog(dialog) {

        this.menuAccessshow = false
        this.value1 = ''
        this.editForm1 = {
          loginName: '',
          groupId: '',
          password: '',
        }
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/mch/downOn.vue